import React from "react"
import {useTranslation} from "react-i18next"

// Components
import DoctorStatsPaper from "../DoctorStatsPaper"

// HOCs
import withDoctorStats, {WithDoctorStatsProps} from "../../hoc/withDoctorStats"

// Styles
import useStyles from "./styles"

/**
 * @param props
 */
function DoctorStatsContainer(props: WithDoctorStatsProps) {
    const {fetchingStats, fetchStats, stats} = props;
    const styles = useStyles();
    const [t] = useTranslation();

    React.useEffect(() => {
        fetchStats()
    }, [fetchStats]);

    if (stats === null) {
        return null
    }

    return (
        <div className={styles.container}>
            <DoctorStatsPaper
                title={t("stats.today")}
                number={stats.day.reviewed}
                isLoading={fetchingStats}
            />
            <DoctorStatsPaper
                title={t("stats.week")}
                number={stats.week.reviewed}
                isLoading={fetchingStats}
                className={styles.minor}
            />
            <DoctorStatsPaper
                title={t("stats.month")}
                number={stats.month.reviewed}
                isLoading={fetchingStats}
                className={styles.minor}
            />
            <DoctorStatsPaper
                title={t("stats.all_time")}
                number={stats.alltime.reviewed}
                isLoading={fetchingStats}
                className={styles.minor}
            />
        </div>
    )
}

export default withDoctorStats(DoctorStatsContainer)
